<template>
	<div style="margin-bottom:200px;background-color:#FFF;">
		<a-tabs default-active-key="1" @change="callback" style="padding:10px">
			<a-tab-pane key="1" tab="基本信息">
				<a-descriptions title="用户信息" :column=1 bordered>
					<a-descriptions-item label="用户名（手机号）">
						{{info.mobile}}
					</a-descriptions-item>
					<a-descriptions-item label="真实姓名">
						{{info.realName}}
					</a-descriptions-item>
					<a-descriptions-item label="所属金融机构">
						{{info.department}}
					</a-descriptions-item>



				</a-descriptions>
			</a-tab-pane>
			<a-tab-pane key="2" tab="修改密码" force-render>
				<a-form-model :model="ruleForm" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
					<a-form-model-item has-feedback label="旧密码:" prop="oldpassword">
						<a-input-password v-model="ruleForm.oldpassword" />
					</a-form-model-item>
					<a-form-model-item has-feedback label="新密码:" prop="newpassword">
						<a-input-password v-model="ruleForm.newpassword" />
					</a-form-model-item>
					<a-form-model-item has-feedback label="再次输入新密码:" prop="newpasswordrep">
						<a-input-password v-model="ruleForm.newpasswordrep" />
					</a-form-model-item>
<!--					<a-form-model-item label="请输入验证码:" prop="code">
						<a-input v-model="ruleForm.code" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" />
						<a-button class="code" :disabled="codeState" :loading="sendCoedLoading" loading-text="发送中.."
							@click="send">{{codeText}}</a-button>
					</a-form-model-item>-->
					<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
						<a-button type="primary" @click="changepwd">
							修改
						</a-button>
						<a-button style="margin-left: 10px;">
							取消
						</a-button>
					</a-form-model-item>
				</a-form-model>
			</a-tab-pane>
      <a-tab-pane key="3" tab="受理设置" force-render v-if="storeAccount.roleId==1024">
        <a-form-model :model="remindForm" ref="remindForm" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="remindRules">
          <a-form-model-item label="受理模式">
            <a-radio-group v-model="remindForm.type">
              <a-radio :value="1">
                集中管理模式
              </a-radio>
              <a-radio :value="0">
                分支机构受理模式
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="管理员手机号:" prop="phone">
            <a-input v-model="remindForm.phone" :maxLength="11" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" />

          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button type="primary" @click="updateRemind">
              确认修改
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
			<a-tab-pane key="4" tab="消息中心">
<!--				<div>
					<a-button @click="sendmessage">发送消息</a-button>
				</div>-->
				<a-table :columns="columns" rowKey="id" :dataSource="messages" :pagination="pagination"
					@change="handleTableChange" :style="{ 'margin-top': '20px' }" class="home-table">
					<template slot="status" slot-scope="text, record">
						<a v-if="text === 0" @click="setRead(record.id)">设为已读</a>
					</template>
				</a-table>
			</a-tab-pane>
		</a-tabs>

		<a-modal title="发送消息" :visible="visible" @ok="handleOk" @cancel="handleCancel">
			<a-select show-search :value="value" placeholder="请搜索信息接收者" style="width: 200px"
				:default-active-first-option="false" :show-arrow="false" :filter-option="false"
				:not-found-content="null" @search="handleSearch" @change="handleChange">
				<a-select-option v-for="p in persons" :key="p.id" :value="p.id">
					{{ p.name }}
				</a-select-option>
			</a-select>
			<a-textarea v-model="message" placeholder="请输入要发送的消息" :auto-size="{ minRows: 3, maxRows: 5 }" />

		</a-modal>
	</div>
</template>

<script>
	import {
		getinfo,
		sendCode,
		change,
		search,
		sendMessage,
		getList,
		setReaded
	} from "@/api/personal/personal"
  import {
    getRemind,
    updateRemind
  } from "@/api/operate/employer"
  import {mapGetters} from "vuex";
  import axios from "axios";

	const columns = [{
			title: "发送人",
			dataIndex: "sender",
			sorter: true,

			scopedSlots: {
				customRender: "sender"
			}
		},
		{
			title: "发送部门",
			dataIndex: "department",

		},
		{
			title: "发送时间",
			dataIndex: "create_At",

		},
		{
			title: "发送内容",

			dataIndex: "content",
			scopedSlots: {
				customRender: "context"
			},

		},
		{
			title: "操作",

			dataIndex: "status",
			scopedSlots: {
				customRender: "status"
			},

		}
	];
	export default {
		name: "dwgrzx",
    computed: {
      ...mapGetters(["storeAccount"])
    },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.initInfo();
				vm.initList();



			});


		},
		data() {
			
				//验证密码
				let checkPassWord = (rule, value, callback) => {
					const reg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
					if (value && !reg.test(value)) {
						callback('密码格式不正确，密码长度最少8位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符');
					}
					callback();
				};
				//对比新密码验证
				let checkPassWordNew = (rule, value, callback) => {
					if (value !== this.ruleForm.newpassword) {
						callback('2次密码不匹配请检查重新输入');
					}
					callback();
				};
      let comparePhone =(rule, value, callback) => {
        let reg = /^(13[0-9]{9})|(147[0-9]{8})|(145[0-9]{8})|(198[0-9]{8})|(17[0-9]{9})|(15[0-9][0-9]{8})|(18[0-9][0-9]{8})$/;
        if (value && !reg.test(value)) {
          callback('请输入正确的手机号码');
          return ;
        }
            callback();
      };
			return {
				messages: [],
				spinning: false,
				message: "",
				visible: false,
				value: undefined,
				persons: [],
				wait: 60,
				codeState: false,
				codeText: "获取验证码",
				sendCoedLoading: false,
				code: "",

				pagination: {
					current: 1,
					pageSize: 10,
					total: 0
				},
				columns,
				newaccount: "",
				current: 0,
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 8
				},
				oldpassword: "",
				newpassword: "",
				newpasswordrep: "",
				newphone: "",
				info: {},
				ruleForm:{
					oldpassword: "",
					newpassword: "",
					newpasswordrep: "",
					code: "",
				},
        remindForm:{
          type: "",
          phone: "",
        },
        remindRules : {
          //提醒手机
          phone: [{
            required: true,
            message: '该项为必填项',
          },{
            validator: comparePhone,
          } ],
        },
				rules: {
					//旧密码
					oldpassword: [{
						required: true,
						message: '该项为必填项',
					}, ],
					//新密码
					newpassword: [{
							required: true,
							message: '该项为必填项',
						},
						{
							validator: checkPassWord,
						}
					],

					//再次输入新密码
					newpasswordrep: [{
							required: true,
							message: '该项为必填项',
						},
						{
							validator: checkPassWordNew,
				
						}
					],
					//验证码
					code: [{
							required: true,
							message: '该项为必填项',
						},
						{
							len:6,
							message: '验证码长度必须为6位且必须为数字',
							pattern: /^\d{6}$/, //正则：6位纯数字
						}
					],
				},

			}
		},




		methods: {
			setRead(id) {
				setReaded(id)
					.then(res => {
						this.$message.success("设置已读成功！");
						this.initList();
					})
			},
			handleTableChange(page) {
				this.pagination.current = page.current;
				this.initList();
				this.spinning = false;
			},
			initList() {
				this.spinning = true;
				getList(this.pagination.current).then(res => {
					if (res.data.success === "TRUE") {
						this.spinning = false;
						this.messages = res.data.data.page.list;
						this.pagination = {
							current: res.data.data.page.pageNum,
							pageSize: res.data.data.page.pageSize,
							total: res.data.data.page.total
						};
					}
				});
			},
			sendmessage() {
				this.visible = true;
			},
			handleOk(e) {

				sendMessage(this.value, this.message)
					.then(res => {
						this.$message.success("发送成功！");
					}).catch(res => {
						this.$message.error("服务器错误请稍后再试！")
					})


				this.value = "";
				this.message = "";
				this.visible = false;
			},
			handleCancel(e) {
				this.visible = false;
				this.value = "";
				this.message = "";

			},

			handleSearch(value) {
				search(value)
					.then(res => {
						this.persons = res.data.data.person;
					})
			},
			handleChange(value) {
				console.log(value)
				this.value = value;
			},
			send() {
				this.codeState = true;
				this.sendCoedLoading = true;

				sendCode(this.info.mobile)
					.then(res => {
						this.$message.success("发送成功");
						this.sendCoedLoading = false;
						this.timer();
					}).catch(() => {
						this.$message.error("发送失败！请稍后再试!");
					})
			},
			//验证码计时器
			timer() {
				if (this.wait == 0) {
					this.codeState = false;
					this.codeText = "获取验证码";
					this.wait = 60;
				} else {
					this.codeState = true;
					this.codeText = this.wait + "s后重新发送";
					this.wait--;
					setTimeout(() => {
						this.timer()
					}, 1000)
				}
			},

			changepwd() {
				this.$refs.ruleForm.validate(valid => {
					if (valid) {
					if (this.ruleForm.newpassword !== this.ruleForm.newpasswordrep) {
						this.$message.error("两次输入密码不一致，请重新输入！");
						return;
					}
					change(this.info.mobile, this.ruleForm.oldpassword, this.ruleForm.newpassword, 518888)
						.then(res => {
							if (res.message === "验证码错误") {
								this.$message.error("验证码错误，请重新输入！");
								return;
							}
							this.$message.success("修改成功")
						}).catch(() => {
							this.$message.error("服务器出错！请稍后再试!");
						})
					} else {
					  console.log('error submit!!');
					  return false;
					}
				});
			},
			initInfo() {
				getinfo()
					.then(res => {
						this.info = res.data.data.info;
						console.log(this.info)
					})
			},



			callback(key) {
			  if(key==3){
          getRemind().then(res => {
            if (res.data.success === "TRUE") {
              this.remindForm = {
                type: res.data.data.type,
                phone: res.data.data.phone
              };
            }
            if(this.remindForm.phone==''||this.remindForm.phone==null){
              this.remindForm.phone=this.storeAccount.mobile
            }
          });
        }

			},
			next() {
				this.current++;
			},
			prev() {
				this.current--;
			},
      updateRemind() {
        this.$refs.remindForm.validate(valid => {
          if (valid) {
            updateRemind(this.remindForm.type, this.remindForm.phone)
                .then(res => {
                  this.$message.success("修改成功")
                }).catch(() => {
              this.$message.error("服务器出错！请稍后再试!");
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
		}
	}
</script>



<style scoped>
	.div1 {
		width: 100%;
		font-size: 14px;
		margin-top: 10px;
		margin-bottom: 10px;
		margin-left: 20px;
	}

	.steps-content {

		margin-top: 16px;
		border: 1px dashed #e9e9e9;
		border-radius: 6px;
		background-color: #fafafa;
		min-height: 100px;
		margin-left: 20px;
		padding-top: 60px;
	}

	.steps-action {

		margin-top: 24px;
	}
</style>
